import { call, put, select } from 'redux-saga/effects';
import { StoreState } from 'store/types';
import { loadReconFailure, loadReconSuccess } from '../actions';
import { ApiError } from 'store/api/types';
import { LoadReconRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { LoadReconResponse, loadRecon } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* loadReconSaga(action: LoadReconRequestAction) {
  const tied = action.payload.tiedToReconciliationGenerate === true;
  const epochAtStart: number = tied
    ? yield select(
        (s: StoreState) => s.vat.reconciliationGenerateLoadEpoch
      )
    : -1;

  try {
    let err: ApiError | null;
    const { tokenId, toDate, mappingId } = action.payload;

    const response: LoadReconResponse = yield call(
      loadRecon,
      tokenId,
      toDate,
      mappingId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    if (tied) {
      const epochNow: number = yield select(
        (s: StoreState) => s.vat.reconciliationGenerateLoadEpoch
      );
      if (epochNow !== epochAtStart) {
        return;
      }
    }

    const reconMap: Map<string, string> = response.data;
    yield put(loadReconSuccess(reconMap));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(loadReconFailure());
  }
}
